import React from "react";
import Background from "../components/Background";
import Navbar from "../components/Navbar";
import back from "../assets/icons/back.svg";

const rockstar_life = require("../assets/videos/rockstartlife.mp4");

function Videography() {
  return (
    <>
      <div className="relative bg-[#000000] h-screen overflow-y-auto overflow-x-hidden z-50">
        <div className=" absolute top-0 left-0 w-full h-full"></div>
        <Navbar type="videography" image={back} />
        <div className="mx-20 z-50 flex justify-center items-center h-screen">
          <video
            src={rockstar_life}
            autoPlay
            muted
            loop
            style={{ objectFit: "cover", width: "100vw", height: "100vh" }}
          />
        </div>
      </div>
    </>
  );
}

export default Videography;
